<template>
    <div class="d-inline-flex">
    <div class="justify-content-center">
        <b-modal
                id="modal"
                v-model="modalShow"
                hide-footer
                size="xl"
                title="AKTUELL"
        >
            <JobListing></JobListing>
        </b-modal>
        <table class="page">
            <!--Header-->
            <tr>
                <td class="header">
                    <table style="width: 100%; height: 202px" class="text-left">
                        <tr>
                            <td style="width: 69%; height: 202px">&nbsp;</td>
                            <td style="width: 31%; height: 429px">&nbsp;</td>
                        </tr>
                        <tr>
                            <td style="width: 69%; height: 4px">
                                <table style="width: 58%; height: 179px">
                                    <tr>
                                        <td style="width: 20%; height: 40px">&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; height: 62px">&nbsp;</td>
                                        <td style="width: 18%; height: 62px">
                                            <font face="Arial" style="font-size: 14px; font-weight: 700" color="#2B7AAD">
                                                Adresse<br>
                                                &nbsp;<br>
                                                &nbsp;</font>
                                        </td>
                                        <td style="width: 150%; height: 62px">
                                            <font face="Arial" style="font-size: 14px">Germersheimer Stra&szlig;e 40<br>
                                                &nbsp; 76879&#8206; Ottersheim bei Landau<br>
                                                &nbsp; DEUTSCHLAND</font></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; height: 38px">&nbsp;</td>
                                        <td style="width: 18%; height: 38px">
                                            <font face="Arial" style="font-size: 14px; font-weight: 700" color="#2B7AAD">
                                                Telefone</font>
                                        </td>
                                        <td style="width: 150%; height: 38px">
                                            <font face="Arial" style="font-size: 14px">06348 9823491</font>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; height: 32px">&nbsp;</td>
                                        <td style="width: 18%; height: 32px">
                                            <font face="Arial" style="font-size: 14px; font-weight: 700" color="#2B7AAD">
                                                Fax</font>
                                        </td>
                                        <td style="width: 150%; height: 32px">
                                            <font face="Arial" style="font-size: 14px">06348 9823492</font>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; height: 32px">&nbsp;</td>
                                        <td style="width: 18%; height: 32px">
                                            <font face="Arial" style="font-size: 14px; font-weight: 700" color="#2B7AAD">
                                                E-Mail</font>
                                        </td>
                                        <td style="width: 150%; height: 32px">
                                            <p id="emailobfuscated" style="margin-bottom: 0px"><canvas width="392" height="32" style="width: 392px; height: 32px; cursor: pointer;"></canvas></p>
                                        </td>
                                    </tr>
                                </table>
                            </td>
                            <td style="width: 31%; height: 231px">
                                <table style="width: 82%; height: 166px">
                                    <tr>
                                        <td>
                                            <div class="text-center"><h3><b-link href="#" @click="showModal">Stellenangebote anzeigen</b-link></h3></div>
                                            <!--<marquee width="100%" height="167" direction="up" scrollamount="1" scrolldelay="10" onmouseover="this.scrollAmount=0" onmouseout="this.scrollAmount=1"><font face="Arial" style="font-size: 13px"><b>Stellenangebot - Paketzusteller/innen</b><br><br>Wir suchen f&uuml;r den Gro&szlig;raum Landau, Neustadt und Karlsruhe Paketzusteller m/w. Es handelt sich hierbei um eine Vollzeitstelle von Montag bis Samstag. Die t&auml;glichen Arbeitszeiten richten sich nach betrieblicher Einteilung, zwischen 9:00 Uhr - 19:00 Uhr, jedoch maximal 10 Stunden am Tag. F&uuml;r die Auslieferung wird ein Transporter zur Verf&uuml;gung gestellt. <br><br>Ihre Aufgaben umfassen folgende Bereiche: <br>Tourenplanung <br>Auslieferung der Ware an Privat- und Gesch&auml;ftskunden <br>Bedienung eines Handscanners<br><br><b>Voraussetzungen: </b><br>F&uuml;hrerschein der Kl. B bis 3,5t <br>Erfahrung mit einem Kleintransporter<br>K&ouml;rperlich fit und belastbar<br>Zeitlich flexibel<br><br>Haben wir Ihr Interesse geweckt?<br>Dann senden Sie uns Ihre Bewerbung und Ihren Lebenslauf an folgende Emailadresse: <a href="mailto:info@zylogistik.com">info@zylogistik.com</a> <br>&nbsp;<br>&nbsp;<br>&nbsp;<br><b>Ausbildung zur Fachkraft f&uuml;r KEP (m/w)</b><br><br><b>Der Job:</b><br>Die Ausbildungsdauer zur Fachkraft f&uuml;r Kurier-, Express- und <br>Postdienstleistungen bel&auml;uft sich auf 2 Jahre; Gegenstand der Ausbildung <br>sind folgende Fertigkeiten und Kenntnisse: Arbeitsorganisation, <br>Arbeitsplanung, Kommunikation und Kooperation, Dienstleistungsangebot, <br>rechtliche Rahmenbedingungen, Qualit&auml;tssicherung, Annahme und Abholung, <br>Umschlag und Auslieferung, Kassenf&uuml;hrung<br><br><b>Das Angebot:</b><br>eine Ausbildungsverg&uuml;tung von durchschnittlich 700 Euro,<br>gute &Uuml;bernahmechancen nach der Ausbildung, schnell gro&szlig;e <br>Eigenverantwortung durch eigenst&auml;ndige Zustellung, verm&ouml;genswirksame <br>Leistungen<br><br><b>Die Anforderung:</b><br>Min. 18 Jahre, Deutsch in Wort und Schrift, min. F&uuml;hrerscheinklasse B <br>bzw. C1 w&uuml;nschenswert, Guter bis sehr guter Hauptschulabschluss oder <br>Mittlere Reife<br>Freude an praxisorientierter Arbeit im Paketgesch&auml;ft<br>Begeisterungsf&auml;higkeit und hohes Engagement<br><br><b>Kontakt:</b><br>Bitte schicken Sie Ihre vollst&auml;ndigen Bewerbungsunterlagen an die <br>Personalabteilung.<br><br>Wir versichern Ihnen, dass wir Ihre Bewerbung umgehend bearbeiten.<br><br><b>Stellenangebot - Fahrer / Paketzusteller (m/w) in Vollzeit f&uuml;r Mannheim</b><br><br><br>Als Partner f&uuml;r unseren neuen Kunden Amazon suchen wir im Gro&szlig;raum Mannheim jetzt zus&auml;tzliche Kollegen.<br><br>Wir suchen deshalb ab sofort mehrere<br><br>Paketzusteller (m/w)<br><br>Deine Kenntnisse und Fertigkeiten:<br>-Einsatzbereitschaft, Zuverl&auml;ssigkeit, freundliches Auftreten<br>-F&uuml;hrerschein Klasse B und Fahrpraxis<br>-F&uuml;hrungszeugnis ohne Eintr&auml;ge<br><br>Das erwartet Dich:<br>-Freundliches, mehrsprachiges Team<br>-Tolle Arbeitspl&auml;tze in neuwertigen Mercedes Vitos oder VW T6<br>-Faire Bedingungen und ein neues innovatives Konzept<br>-Gute, leistungsorientierte Verg&uuml;tung<br>-Festlohn ab 2100 € Brutto<br>-Zus&auml;tzlich t&auml;glicher Verpflegungs-Zuschlag nach erfolgter Einarbeitung<br>-Du arbeitest in einer 5-Tage-Woche von Montag bis Samstag mit einem wechselnden freien Tag<br>-Arbeitsstart ist zwischen 10 und 12 Uhr vormittags<br>-Deine Pakete sind vorsortiert nach Adressen, haben ein Gewicht von bis zu 6 kg, und sind in Bags untergebracht. Sehr einfaches Beladen in ca. 10 Min. und keine Suche w&auml;hrend der Fahrt.<br>-Dein Scanner ist dein Navi und Telefon muss nur Start dr&uuml;cken und deinem Navi folgen keine Suche mehr keine Eingabe von Adressen notwendig.<br><br>Wir bieten einen sicheren und abwechslungsreichen Arbeitsplatz in einem stark wachsenden Unternehmen mit Aufstiegsm&ouml;glichkeiten.<br><br>Interesse? Wir laden Dich gerne zu einem Probetag ein.</font></marquee>-->
                                        </td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <!--Middle-->
            <tr>
                <td class="middle">
                    <table style="width: 100%; height: 260px">
                        <tr>
                            <td style="width: 54%; height: 120px">&nbsp;</td>
                            <td style="width: 46%; height: 120px">&nbsp;</td>
                        </tr>
                        <tr>
                            <td style="width: 54%; height: 260px">&nbsp;</td>
                            <td style="width: 46%; height: 260px">
                                        <b-form style="width: 480px; height: 260px;" @submit="onSubmit" @reset="onReset" v-if="show" class="text-left align-bottom">
                                            <b-form-row>
                                                <b-col cols="3">
                                                    <label for="name" size="sm">Name:</label>
                                                </b-col>
                                                <b-col cols="9">
                                                    <b-form-input required id="name" size="sm" v-model="form.name"></b-form-input>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col cols="3">
                                                    <label for="mail" size="sm">E-Mail:</label>
                                                </b-col>
                                                <b-col>
                                                    <b-form-input required id="mail" size="sm" type="email" class="mt-0" v-model="form.email"></b-form-input>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col cols="3">
                                                    <label for="phone" size="sm">Telefon:</label>
                                                </b-col>
                                                <b-col>
                                                    <b-form-input id="phone" size="sm" v-model="form.phone"></b-form-input>
                                                </b-col>
                                            </b-form-row>
                                            <b-form-row>
                                                <b-col cols="3">
                                                    <label for="message" size="sm">Nachricht:</label>
                                                </b-col>
                                                <b-col>
                                                    <b-form-textarea required id="message" rows="3" max-rows="6" size="sm" v-model="form.message"></b-form-textarea>
                                                </b-col>
                                            </b-form-row>
                                            <b-button v-if="success === false" class="float-right mt-2 mb-0" type="submit">Absenden</b-button>
                                            <b-button v-if="success === true" disabled variant="success" class="float-right mt-2 mb-0">Erfolgreich</b-button>
                                        </b-form>
                            </td>
                        </tr>
                    </table>
                </td>
            </tr>
            <!--Footer-->
            <tr>
                <td class="footer"></td>
            </tr>
        </table>
    </div>
    </div>
</template>

<script>
    import EmailObfuscate from 'email-obfuscate';
    import JobListing from '@/components/JobListing.vue'

    export default {
        name: "Home",
        components: {
            JobListing
        },
        data() {
            return {
                emptyform: {
                    email: '',
                    name: '',
                    message: '',
                    phone: ''
                },
                form: {},
                success: false,
                show: true,
                modalShow: true
            }
        },
        created() {
            this.form = Object.assign({}, this.emptyform);
        },
        mounted() {
            const el = window.document.getElementById('emailobfuscated');
            EmailObfuscate(el, {
                // Email construct: name@domain.tld
                name: 'info',
                domain: 'zylogistik',
                tld: 'com',
                // Alternate Text
                altText: 'Email'
            });
            this.$i18n.locale = "de";
        },
        methods: {
            onSubmit(event) {
                event.preventDefault();
                let currentObj = this;
                this.axios.post('post.php', {
                    data: {
                        form: this.form
                    }
                }).then(function () {
                    currentObj.success = true;
                    currentObj.onReset(event);
                }).catch(function () {
                    currentObj.success = false;
                });
            },
            onReset(event) {
                event.preventDefault();
                this.form = Object.assign({}, this.emptyform);
                this.show = false;
                this.$nextTick(() => {
                    this.show = true
                })
            },
            showModal() {
                this.modalShow = true;
            }
        }
    }
</script>

<style scoped>
    .page {
        width: 1050px;
        height: 1052px;
    }
    .header {
        width: 100%;
        height: 669px;
        background-image: url('../assets/images/header.jpg');
    }
    .middle {
        width: 100%;
        height: 169px;
        background-image: url('../assets/images/middle.jpg');
    }
    .middle {
        width: 100%;
        height: 382px;
        background-image: url('../assets/images/footer.jpg');
    }

</style>
